import { getDefaultState } from '../company/index';
import companyStoreMutations from '@constans/store/company/companyStoreMutations';
const mutations = {
    [companyStoreMutations.SET_BORDERS]: (state, borders) => state.tenant_payload.border_ids = borders,
    [companyStoreMutations.SET_TENANTS]: (state, list) => state.tenants = list,
    [companyStoreMutations.SET_PAYLOAD]: (state, response) => {
        state.tenant_payload = response;
        state.tenant_payload.email_again = response.email;
        // state.tenant_payload.area_ids = response.areas.map((i: any) => i.id)
        state.tenant_payload.configure_estate_property_residence_types_ids = response.residence_types.map((i) => i.id);
    },
    [companyStoreMutations.RESET_PAYLOAD]: (state) => Object.assign(state, getDefaultState()),
    [companyStoreMutations.CHANGE_STATE]: (state, field) => {
        Object.keys(field).forEach(key => {
            const currentState = field.base !== undefined ? state[field.base] : state;
            // Do not save the "key base" in state.
            if (key !== 'base') {
                currentState[key] = field[key];
            }
        });
    },
    // [companyStoreMutations.SET_AREA]: (state, ids) => state.tenant_payload.area_ids = ids,
    [companyStoreMutations.SET_PRE_BOOKINGS]: (state, viewings) => {
        state.viewings.list = viewings['pre-bookings'];
        state.viewings.total = viewings.total;
    }
};
export default mutations;
